export default "__VITE_ASSET__DpQdXMjJ__"